// Simple localStorage-backed history of copied promo codes.
const KEY = "couponer_copy_history";
const MAX = 60;

export function addToCopyHistory(coupon) {
  try {
    const raw = localStorage.getItem(KEY);
    let list = raw ? JSON.parse(raw) : [];
    list = list.filter((c) => c.id !== coupon.id);
    list.unshift({
      id: coupon.id,
      store: coupon.store,
      store_url: coupon.store_url,
      code: coupon.code,
      title: coupon.title,
      discount_label: coupon.discount_label,
      ts: Date.now(),
    });
    if (list.length > MAX) list = list.slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {}
}

export function getCopyHistory() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function clearCopyHistory() {
  try {
    localStorage.removeItem(KEY);
  } catch {}
}
